var render = function () {
  var _vm$created$, _vm$created$2, _vm$created$3, _vm$created$4;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDialogActive,
      "absolute": true,
      "persistent": true,
      "loading": _vm.isLoading,
      "rightLoading": _vm.isCreating || _vm.isSending,
      "leftText": _vm.leftText,
      "rightText": _vm.rightText,
      "rightDisabled": _vm.isRightDisabled,
      "title": _vm.stepTitle,
      "supressKeyboardActions": true,
      "subtitle": _vm.step === _vm.StepEnum.ENTER_EMAILS ? _vm.$t('snapshot.signRequest.enterReceiversInfo') : ''
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "close": _vm.close,
      "leftClick": _vm.onLeftClick,
      "rightClick": _vm.onRightClick
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_vm.step === _vm.StepEnum.ENTER_EMAILS ? [_c('v-card-text', [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_vm._v(" " + _vm._s(_vm.$t("snapshot.signRequest.newRequest")) + " ")]), _c('v-form', {
    model: {
      value: _vm.isFormValid,
      callback: function callback($$v) {
        _vm.isFormValid = $$v;
      },
      expression: "isFormValid"
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.emailSuggestions,
      "label": _vm.$t('common.nouns.email'),
      "rules": _vm.rules(_vm.RulesEnum.EMAIL_RULE),
      "outlined": "",
      "clearable": "",
      "solo": "",
      "flat": "",
      "persistent-hint": ""
    },
    model: {
      value: _vm.email,
      callback: function callback($$v) {
        _vm.email = $$v;
      },
      expression: "email"
    }
  })], 1)], 1)] : _vm.step === _vm.StepEnum.SEND_MAIL ? [_c('preselect-template-card', {
    ref: "preselectTemplateCard",
    attrs: {
      "to": [(_vm$created$ = _vm.created[0]) === null || _vm$created$ === void 0 ? void 0 : _vm$created$.email],
      "context": _vm.templateContext((_vm$created$2 = _vm.created[0]) === null || _vm$created$2 === void 0 ? void 0 : _vm$created$2.sharedContent),
      "refs": _vm.templateRefs((_vm$created$3 = _vm.created[0]) === null || _vm$created$3 === void 0 ? void 0 : _vm$created$3.sharedContent),
      "isTicketEnabled": false,
      "attachmentFileFilters": [],
      "partnerId": _vm.partnerId,
      "templateKey": _vm.PreselectTemplateKeysEnum.REQUEST_SNAPSHOT_SIGNATURE_MAIL,
      "language": _vm.defaultLanguage
    }
  }), _c('div', {
    staticClass: "d-flex"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "small": "",
      "color": "info"
    },
    on: {
      "click": function click($event) {
        return _vm.copySharedContent(_vm.created[0].sharedContent);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-content-copy")]), _vm._v(" " + _vm._s(_vm.$t("common.verbs.copyLink")) + " ")], 1)], 1)] : _vm.step === _vm.StepEnum.SUCCESS ? [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-img', {
    staticClass: "mt-8",
    attrs: {
      "align": "center",
      "justify": "center",
      "contain": "",
      "max-height": "250px",
      "src": require("@/assets/undraw/undraw_mail_sent_re_0ofv.svg")
    }
  })], 1), _c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("snapshot.signRequest.mailSent")) + " ")]), _c('v-card-subtitle', [_vm._v(" " + _vm._s((_vm$created$4 = _vm.created[0]) === null || _vm$created$4 === void 0 ? void 0 : _vm$created$4.email) + " ")])], 1)] : _vm._e()], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }